import * as React from "react";
import { ThemeToggle } from "@/components/theme-toggle";

export default function CenteredNotification({ children }: React.PropsWithChildren<{}>) {
    return (
        <div className="relative min-h-screen bg-shell text-foreground flex flex-col items-center justify-center px-4 py-10">
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 overflow-hidden"
            >
                <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-[hsl(var(--brand-green)/0.18)] blur-3xl" />
                <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[hsl(var(--brand-rose)/0.16)] blur-3xl" />
            </div>
            <div className="fixed top-4 right-4 z-50">
                <ThemeToggle />
            </div>
            <div className="relative z-10 w-full max-w-md">{children}</div>
        </div>
    );
}
